import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const MapTag = ({
  className = "text-primary",
  viewBox = "0 0 30 38",
  width = 30,
  height = 38,
  disabled = false,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge(disabled ? "opacity-20" : "cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={disabled ? undefined : onClick}
  >
    <title>Pencil</title>
    <path
      d="M14.9997 19.0003C12.983 19.0003 11.333 17.3503 11.333 15.3337C11.333 13.317 12.983 11.667 14.9997 11.667C17.0163 11.667 18.6663 13.317 18.6663 15.3337C18.6663 17.3503 17.0163 19.0003 14.9997 19.0003ZM25.9997 15.7003C25.9997 9.04532 21.1413 4.33366 14.9997 4.33366C8.85801 4.33366 3.99967 9.04532 3.99967 15.7003C3.99967 19.9903 7.57467 25.6737 14.9997 32.457C22.4247 25.6737 25.9997 19.9903 25.9997 15.7003ZM14.9997 0.666992C22.6997 0.666992 29.6663 6.57032 29.6663 15.7003C29.6663 21.787 24.7713 28.992 14.9997 37.3337C5.22801 28.992 0.333008 21.787 0.333008 15.7003C0.333008 6.57032 7.29967 0.666992 14.9997 0.666992Z"
      fill="#1C67AD"
    />
  </svg>
);
